export enum FileExtension {
  PDF = '.pdf',
  STL = '.stl',
}
